import { RegisteredRoundSortType } from 'types/form/professor';
import { TPagingResponse } from './api';

export enum schoolYear {
  first = 1,
  second = 2,
  third = 3,
}

export enum Score {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
}

export enum StudentListSortBy {
  Name = 'name',
  LoginId = 'loginId',
  SchoolYear = 'schoolYear',
  Score = 'score',
}

export enum StudentListSortByFormLabel {
  Name = '이름',
  LoginId = '학번',
  SchoolYear = '학년',
  Score = '최근회차평가',
}

export enum StudentChartListSortBy {
  LastEvaluatedAt = 'lastEvaluatedAt',
  Score = 'score',
}

export enum StudentChartListSortByFromLabel {
  LastEvaluatedAt = '평가일시',
  Score = '평가결과',
}

export type TStudentListParams = {
  page: number;
  size: number;
  courseInfoId: number;
  registrationStatus?: string;
  searchWord?: string;
  schoolYear?: schoolYear[];
  score?: Score[];
  sortBy?: StudentListSortBy;
  isAsc?: boolean;
};

export type TStudentTableInfo = {
  userId: number;
  name: string;
  loginId: string;
  schoolYear: number;
  phoneNum: string;
  courseName: string;
  studClass: string;
  score: string;
};

export type TStudentList = {
  studentList: TStudentTableInfo[];
};

export type TStudentListResponse = TPagingResponse<TStudentList>;

export type TStudentDetailInfoResponse = {
  userId: number;
  studentName: string;
  loginId: string;
  phoneNum: string;
  courseId: number;
  courseName: string;
  studClass: string;
  chartRound: number;
  chartStatus: object;
};

export type TStudentChartListParams = {
  page: number;
  size: number;
  courseInfoId: number;
  chartRound: number;
  sortBy?: StudentChartListSortBy;
  isAsc?: boolean;
};

export type TStudentChartTableInfo = {
  chartRoundAndChartName: string;
  chartType: number;
  chartTypeName: string;
  patientName: string;
  complaint: string;
  lastEvaluatedAt: string;
  score: string;
  evaluationChartId: number;
  evaluationRound: number;
};

export type TStudentChartList = {
  chartDetailRespList: TStudentChartTableInfo[];
};

export type TStudentChartListResponse = TPagingResponse<TStudentChartList>;

export type TCourseInfo = {
  courseInfoId: number;
  courseNameAndStudClass: string;
  chartRound: number;
};

export type TCourseListForRegisterChartResponse = {
  courseInfoForPostResponseList: TCourseInfo[];
};

export type TRegisterRoundParams = {
  courseInfoId: number;
  chartRound: number;
  chartName: string;
  chartTypeList: number[];
  firstSubmitStartDate: string;
  firstSubmitEndDate: string;
  secondSubmitStartDate?: string;
  secondSubmitEndDate?: string;
};

export type TRegisteredRoundListParams = {
  page: number;
  size: number;
  courseInfoId?: number;
  searchWord?: string;
  sortBy?: RegisteredRoundSortType;
  isAsc?: boolean;
  isClosed: boolean;
};

export type TRegisteredChartInfo = {
  registeredChartId: number;
  courseName: string;
  studClass: string;
  chartRoundAndChartName: string;
  classSize: number;
  firstSubmitEndDate: string;
  secondSubmitEndDate?: string;
};

export type TRegisteredRoundList = {
  registeredChartList: TRegisteredChartInfo[];
};

export type TRegisteredRoundListResponse =
  TPagingResponse<TRegisteredRoundList>;

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type TRegisteredRoundDetailResponse = {
  registeredChartId: number;
  courseName: string;
  studClass: string;
  chartRound: number;
  chartName: string;
  chartType: number[];
  firstSubmitStartDate: string;
  firstSubmitEndDate: string;
  secondSubmitStartDate?: string;
  secondSubmitEndDate?: string;
};

export type TEditRegisteredRoundParams = {
  firstSubmitStartDate: string;
  firstSubmitEndDate: string;
  secondSubmitStartDate?: string;
  secondSubmitEndDate?: string;
};

export type TCheckIsNeedPasswordResponse = {
  isNeedPassword: boolean;
};

export type TDeleteRegisteredRoundParams = {
  password?: string;
};

export type TEvaluationChartCountParams = {
  courseInfoId: number;
  chartRound: number;
};

export type TEvaluationChartCountInfo = {
  chartTypeName: string;
  chartType: number;
  chartEvaluatedCount: string;
};

export type TEvaluationChartCountResponse = {
  totalStudentCount: number;
  chartEvaluatedCountList: TEvaluationChartCountInfo[];
};

export type TEvalautionChartForGradeParams = {
  page: number;
  size: number;
  courseInfoId: number;
  chartRound: number;
  chartType?: number;
  score?: string;
  isNeedEvaluation?: boolean;
  searchWord?: string;
};

export type TEvaluationChartForGradeInfo = {
  chartType: number;
  chartTypeName: string;
  studentUserId: number;
  studentLoginId: string;
  studentName: string;
  score: string;
  lastSubmitAt: string;
  lastEvaluatedAt: string;
  evaluationChartId: number;
  evaluationRound: number;
};

export type TEvaluationChartForGradeList = {
  evaluateChartList: TEvaluationChartForGradeInfo[];
};

export type TEvalautionChartForGradeResponse =
  TPagingResponse<TEvaluationChartForGradeList>;

export type TEvaluationChartCountInfoActive = {
  chartType: number;
  evaluationChartId: number;
  evaluationRound: number;
};

export type TEvaluationChartList = {
  patientInfo: string;
  courseName: string;
  chartRoundAndChartName: string;
  evaluationChartInfoActiveList: TEvaluationChartCountInfoActive[];
};

export type TChartInfoListByPatientResponse = {
  evaluationChartInfo: TEvaluationChartList;
};

export type TEvaluationChartFeedbackHistoryParams = {
  evaluationChartId: number;
  userId: number;
  feedbackId: number;
};

export type TEvaluationHistory = {
  feedbackDate: string;
  score: number;
};

export type TEvaluationChartFeedbackHistoryResponse = {
  evaluationHistoryList: TEvaluationHistory[];
};

export type TStatisticsByRoundParams = {
  courseInfoId: number;
  chartRound: number;
};

export type TFailureLists = {
  rank: number;
  chartName: string;
  allStudentCount: number;
  failureStudentCount: number;
  averageScore: number;
  failureAverageScore: number;
};

export type TStatisticsByRoundResponse = {
  allStudentCount: number;
  studentCountByScoreRange: {
    firstCount: number;
    firstPercent: number;
    secondCount: number;
    secondPercent: number;
    thirdCount: number;
    thirdPercent: number;
    fourthCount: number;
    fourthPercent: number;
    fifthCount: number;
    fifthPercent: number;
  };
  allChartAverageScore: {
    chartType: number;
    chartTypeName: string;
    averageScore: number;
  }[];
  failureLists: TFailureLists[];
};

export type TStatisticsByStudentParams = {
  courseInfoId: number;
  chartRound: number;
  studentUserId: number;
};

export type TStudentChartScoreList = {
  rank: number;
  chartType: number;
  chartTypeName: string;
  classAverage: number;
  studentAverage: number;
  difference: number;
  differenceScore: number;
  evaluationChartId: number;
  evaluationRound: number;
};

export type TStatisticsByStudentResponse = {
  averageDTO: {
    studentAverage: number;
    classAverage: number;
    allAverage: number;
  };
  chartRoundGraphList: {
    chartRound: number;
    averageScore: number;
  }[];
  studentChartScoreList: TStudentChartScoreList[];
};
